// Props Proxy HOC for switching between a 'normal' mode (list of recipient
// labels), and 'editing' (expanded) mode (search input with dropdown).
import React from 'react'
import PropTypes from 'prop-types'
import { getDisplayName } from 'util/hoc'

import debug from 'util/debug'

function withEditMode(WrappedComponent) {
  class WithEditMode extends React.Component {
    static propTypes = {
      // Whether to start in 'Edit' mode
      startInEditMode: PropTypes.bool,
    }

    static defaultProps = {
      startInEditMode: false,
    }

    state = { editing: false }

    componentDidMount() {
      if (this.props.startInEditMode) this.startEditing()
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.startInEditMode && !this.props.startInEditMode) {
        this.startEditing()
      }
    }

    timeoutID

    startEditing = () => {
      this.setState({ editing: true })
    }

    stopEditing = () => {
      this.setState({ editing: false })
    }

    continueEditing = () => {
      debug('continuing edit mode')
      clearTimeout(this.timeoutID)
      this.startEditing()
    }

    // Will exit editing mode after a short delay, unless you call continueEditing
    // in the meantime. Used to give onClick handlers in the dropdowns time to
    // fire.
    // The default onBlur behaviour, if any, should be passed as the
    // `beforeStop` callback
    maybeStopEditing = (evt, beforeStop) => {
      this.timeoutID = setTimeout(() => {
        debug('maybeStopEditing exiting edit mode (after delay)')

        if (beforeStop) {
          debug('maybeStopEditing executing beforeStop callback')
          beforeStop()
        }
        this.stopEditing()
      }, 150)
    }

    render() {
      const { editing } = this.state
      return (
        <WrappedComponent
          {...this.props}
          editing={editing}
          startEditing={this.startEditing}
          stopEditing={this.stopEditing}
          maybeStopEditing={this.maybeStopEditing}
          continueEditing={this.continueEditing}
        />
      )
    }
  }

  WithEditMode.displayName = `WithEditMode(${getDisplayName(WrappedComponent)})`

  return WithEditMode
}

export default withEditMode
